import { CircularProgress } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import newsArticlesStaticData from "../../constant/newsArticlesStaticData";
import "./AboutUs.css";

const NewsArticles = () => {
  const [visibleCount, setVisibleCount] = useState(5);
  const [loading, setLoading] = useState(false);

  const loadMore = () => {
    setLoading(true);
    setTimeout(() => {
      setVisibleCount((prev) => prev + 5);
      setLoading(false);
    }, 1500);
  };

  return (
    <div className="about-news-container">
      <h2 className="about-news-heading">News & Article</h2>
      <div className="about-news-list">
        {newsArticlesStaticData?.slice(0, visibleCount).map((news) => (
          <Link
            to={news.url}
            target="_blank"
            rel="noopener noreferrer"
            className="about-news-card"
            key={news.id}
          >
            <img
              src={news.image}
              alt={news.title}
              className="about-news-image"
            />
            <div className="about-news-content-box">
              <div className="about-news-content">
                <span className="about-news-category">{news.category}</span>
                <h3 className="about-news-title">{news.title}</h3>
              </div>
              <div className="about-news-meta">
                <div className="about-news-source">{news.source}</div>
                <div className="about-news-date">{news.date}</div>
              </div>
            </div>
          </Link>
        ))}
        {loading && (
          <div className="loader-wrapper">
            <CircularProgress size={28} />
          </div>
        )}

        {/* Load More Button */}
        {!loading && visibleCount < newsArticlesStaticData.length && (
          <div className="load-more-wrapper">
            <button className="load-more-btn" onClick={loadMore}>
              Load More
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsArticles;
